import { FormGroupImpl } from './form-group';
/**
 * Return a new form group implementation.
 *
 * @param key A string that describes this form
 * @param validations Validations to use for the form
 * @param validators Validators that are applied to the form group
 */
export function formGroup(key, validations, validators) {
    if (validators === void 0) { validators = []; }
    return new FormGroupImpl(key, validations, null, validators);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdG9yaWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vbGliL2ZhY3Rvcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQWEsYUFBYSxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBR3ZEOzs7Ozs7R0FNRztBQUNILE1BQU0sVUFBVSxTQUFTLENBQ3ZCLEdBQVcsRUFDWCxXQUEyQixFQUMzQixVQUE0QjtJQUE1QiwyQkFBQSxFQUFBLGVBQTRCO0lBRTVCLE9BQU8sSUFBSSxhQUFhLENBQUksR0FBRyxFQUFFLFdBQVcsRUFBRSxJQUFJLEVBQUUsVUFBVSxDQUFDLENBQUE7QUFDakUsQ0FBQyJ9